import React from 'react';
import './ExportProgressOverlay.css';

const SaveProgressOverlay = ({ progress, status = 'ok' }) => (
  <div className={`export-progress-overlay export-progress-overlay--${status === 'error' ? 'error' : 'running'}`}>
    <div className="export-progress-content">
      <span className={`export-progress-spinner${status === 'error' ? ' is-static' : ''}`} aria-hidden="true" />
      <div className="export-progress-copy">
        <p>{status === 'error' ? 'No se pudo guardar' : 'Guardando cambios'}</p>
        <span>{Math.max(0, Math.min(100, Math.round(Number(progress) || 0)))}%</span>
      </div>
    </div>
    <div className={`export-progress-bar ${status === 'error' ? 'is-error' : 'is-ok'}`}>
      <div
        className={`export-progress-bar-fill ${status === 'error' ? 'is-error' : 'is-ok'}`}
        style={{ width: `${progress}%` }}
      />
    </div>
  </div>
);

export default SaveProgressOverlay;
